import { Request } from "@/common/util"


/**
 * Get helper definitions
 */
export const getHelperDefinitions = () => {
    return Request({
        path: '/helpers/definitions',
        method: 'GET'
    })
}

/**
 * Get helper files
 */
export const getHelperFiles = () => {
    return Request({
        path: '/helpers/files',
        method: 'GET'
    })
}

export const getResources = () => {
    return Request({
        path:'/helpers/resources',
        method: 'GET',
    })
}